import { Button, Col } from "react-bootstrap";
import { useLocalization } from "../../contexts/LocalizationContext";
import { useTheme } from "../../contexts/ThemeContext";
import { PluginsFilters } from "./models/PluginsFilters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { PluginFilterTagsBuilder } from "./models/PluginFilterTagsBuilder";
import { PluginsFilterActionType } from "./models/PluginsFilterActionType";

type AppliedPluginFiltersProps = {
  filters: PluginsFilters;
  handleFiltersChange: (action: PluginsFilterActionType, value?: string | number) => void;
};

export const AppliedPluginFilters = ({ filters, handleFiltersChange }: AppliedPluginFiltersProps) => {
  const { buttonStyle } = useTheme();
  const { translate } = useLocalization();
  const tags = new PluginFilterTagsBuilder(filters).getAll(translate);

  return (
    <Col xs={12} className="d-flex">
      {tags.some((x) => x.value !== "") && (
        <Button
          style={buttonStyle}
          className="me-2 py-0 text-white"
          onClick={() => handleFiltersChange(PluginsFilterActionType.ClearAll)}
        >
          <FontAwesomeIcon className="me-2" icon={faTimesCircle} />
          {translate("common.clearAllFilters")}
        </Button>
      )}
      {tags
        .filter((x) => x.value !== "")
        .map((x, i) => (
          <Button
            key={i}
            style={buttonStyle}
            className="me-2 py-0 text-white"
            onClick={() => handleFiltersChange(x.action, x.value)}
          >
            <FontAwesomeIcon className="me-2" icon={faTimesCircle} />
            <span aria-label={translate("common.removeFilter")} />
            {`${x.type}: ${x.value}`}
          </Button>
        ))}
    </Col>
  );
};
